import React, { useState } from 'react';
import firebase from '../utils/Firebase';
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from 'react-router-dom';


import TopHeader from "../components/TopHeader";
import { notification } from 'antd';
import backBtn from "../img/back_btn.svg";
import 'antd/dist/antd.css';

const AddVendor = () => {

    const [vendor_name, setvendor_name] = useState("");
    const [vendor_image, setvendor_image] = useState("");
    const [vendor_tagline, setvendor_tagline] = useState("");

    const { user, loginWithPopup,logout  } = useAuth0();

    const onSubmit = e => {
        /* 
        preventDefault is important because it
        prevents the whole page from reloading
        */

        e.preventDefault()
        firebase
            .firestore()
            .collection("vendors")
            .add({
                vendor_name,
                vendor_image,
                vendor_tagline

            })
            //.then will reset the form to nothing
            .then(() => setvendor_name(""), setvendor_image(""), setvendor_tagline(''));
            openNotification(vendor_name);

    }

    const openNotification = (vendor_name) => {
        notification.open({
          message: 'Vendor was created successfully !',
          description:
            'Vendor Name : '+vendor_name
        });
      };
    

    return (<>

<Link to="/"><TopHeader pageTitle="Add Vendor" app_logo={backBtn} /></Link>
{user ?
        <div className="container mt-100">
            <div className="row">
                <div className="col-sm-6 mt-4 mx-auto card p-5">
                    <form onSubmit={onSubmit}>
                        <input className="mb-3 mt-0 form-control" required placeholder="Enter Vendor Name"
                            value={vendor_name}
                            name="vendor_name"
                            onChange={e => setvendor_name(e.currentTarget.value)}
                            type="text"
                        />
                        <input className="mb-3 mt-0 form-control" required placeholder="Enter Vendor Image URL"
                            value={vendor_image}
                            name="vendor_image"
                            onChange={e => setvendor_image(e.currentTarget.value)}
                            type="text"
                        />
                        <input className="mb-3 mt-0 form-control" required placeholder="Enter Vendor Tagline"
                            value={vendor_tagline}
                            name="vendor_tagline"
                            onChange={e => setvendor_tagline(e.currentTarget.value)}
                            type="text"
                        />
                        
                        <button style={{ width: "100%" }} className="btn btn-primary">Submit</button>
                        Submitting as : {user.name}
                    </form>
                    <button style={{ width: "100%" }} className="btn btn-primary mt-2"  onClick={() => logout()} >Logout</button>
                </div>
            </div>
        </div>
        :<> 
        <div className="container mt-5">
            <div className="row text-center">
                <div className="col-sm-6 mt-4 mx-auto card p-5">
                <div  className="my-auto"><img src="https://img.freepik.com/free-vector/mobile-login-concept-illustration_114360-83.jpg?size=338&ext=jpg" alt="" width="300px" /> </div>
                <h4>You need to login first to access this page.</h4>
                <button className="btn btn-primary"  onClick={() => loginWithPopup()} >Login Now</button>
                </div>
            </div>
        </div>
       
        </>}

    </>);
}

export default AddVendor;